
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return __webpack_require__.e(/*  | __federation_expose_App */ "66362").then(() => (() => (__webpack_require__(59680))));
},
"./MyAccountDrawer": () => {
return __webpack_require__.e(/*  | __federation_expose_MyAccountDrawer */ "51417").then(() => (() => (__webpack_require__(74257))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };